import { useMsal } from '@azure/msal-react';
import LogoutIcon from '@mui/icons-material/Logout';
import { IconButton } from '@mui/material';

export const SignOutButton = () => {
  const { instance } = useMsal();

  const handleLogout = () => {
    instance.logoutRedirect();
  };

  return (
    <div>
      <IconButton onClick={() => handleLogout()} color="inherit">
        <LogoutIcon fontSize="inherit" />
      </IconButton>
    </div>
  );
};
